/**
 * AlmadarPostWelcomeToAlmadarENAlmadarPostWelcomeToAlmadarENPage
 *
 * Page component for AlmadarPostWelcomeToAlmadarENAlmadarPostWelcomeToAlmadarENPage
 * Path: /blog/welcome-to-almadar
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { AlmadarPostWelcomeToAlmadarENPostPageView as __AlmadarPostWelcomeToAlmadarENPostPageView } from '@/components/traits/AlmadarPostWelcomeToAlmadarENPostPageView';
import { AlmadarPostWelcomeToAlmadarENPostAnalyticsView as __AlmadarPostWelcomeToAlmadarENPostAnalyticsView } from '@/components/traits/AlmadarPostWelcomeToAlmadarENPostAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';

interface AlmadarPostWelcomeToAlmadarENAlmadarPostWelcomeToAlmadarENPageProps {
  // Add any page-level props here
}

export function AlmadarPostWelcomeToAlmadarENAlmadarPostWelcomeToAlmadarENPage(_props: AlmadarPostWelcomeToAlmadarENAlmadarPostWelcomeToAlmadarENPageProps) {
  const __navState = (useLocation().state ?? {}) as EventPayload;

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__AlmadarPostWelcomeToAlmadarENPostPageView config={{ initPayload: __navState }} />
          <__AlmadarPostWelcomeToAlmadarENPostAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default AlmadarPostWelcomeToAlmadarENAlmadarPostWelcomeToAlmadarENPage;
